export const isIos = () => {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

export function isAndroid() {
  return /android/.test(navigator.userAgent.toLowerCase());
}

export const isMobile = () => {
  let isMobile = "DeviceOrientationEvent" in window || "orientation" in window;
  if (/Windows NT|Macintosh|Mac OS X|Linux/i.test(navigator.userAgent)) isMobile = false;
  if (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent)) isMobile = true;
  return isMobile;
};

export const isEmpty = (value) => {
  return ["", null, undefined].indexOf(value) === -1;
};

export const getUrlParams = (arg) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === arg) {
      return pair[1];
    }
  }
  return null;
};
